<template>
  <el-form-item
    :label="input.name"
    :prop="input.overridable ? input.code : null">
    <template slot="label">
      <span>{{ input.name }}</span><br>
      <el-checkbox
         v-model="setManually"
         v-if="input.calculated && input.overridable"
         class="is-small is-gray"
        :disabled="disabled">
        {{ $t('label.set_manually') }}
      </el-checkbox>
    </template>
    <el-row>
      <el-col
         class="el-col--no-line-height"
        :span="14">
        <el-input
           v-if="willBeCalculated"
           size="small"
           class="is-center-text"
          :placeholder="$t('label.will_be_calculated')"
          :disabled="true">
        </el-input>
        <el-input-number
           v-else
           v-model="simple.value"
           size="small"
           class="w-100"
          :step="1"
          :min="input.validation.min"
          :max="input.validation.max"
          :disabled="isDisabled"
          @change="update">
        </el-input-number>
      </el-col>
      <!-- {{ $t('label.suggestions') }}  -->
      <el-col :span="3" class="el-col--offset-1em" v-if="input.expressed_in_unit">
        {{ input.expressed_in_unit }}
      </el-col>
      <el-col :span="3" class="el-col--offset-1em">
        <el-dropdown class="w-100" @command="setValue">
          <el-button :disabled="isDisabled" size="mini">
            <i class="far fa-ellipsis-v"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item v-for="option in input.MeasurementTypeOptions" :key="option.code" :command="String(option.value)">{{ `${option.name} (${option.value}${input.expressed_in_unit || ''})` }}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </el-col>
    </el-row>
  </el-form-item>
</template>

<script>
import { get, has } from 'lodash';

import FormInputAbstract from './cmpt-form-input-abstract';

export default {
  name: 'evolution-settings-form-input-simple',
  mixins: [FormInputAbstract],
  data() {
    return {
      simple: {
        id: null,
        code: null,
        overridable: null,
        value: null,
        description: null,
      },
      setManually: false,
    };
  },
  methods: {
    update(value) {
      this.$emit('set:value', {
        code: this.simple.code,
        overridable: this.simple.overridable,
        data: {
          measurement_type_id: this.simple.id,
          value: Number(value),
        },
      });
    },
    showInput() {
      return this.input.overridable || has(this.input, 'Measurement.value') || has(this.input, 'Measurement.value_text');
    },
    setValue(value) {
      this.simple.value = value;
      this.update(value);
    },
  },
  computed: {
    isDisabled() {
      return this.disabled || !this.input.overridable || (this.input.calculated && !this.setManually);
    },
    willBeCalculated() {
      return this.input.calculated && !this.setManually && this.calculatedFromChanged;
    },
  },
  // watch: {
  //   input() {
  //     const min = get(this.input.validation, 'min') || null;
  //     this.simple.value = get(this.input.Measurement, 'value') || min;
  //     this.update(this.simple.value);
  //   },
  // },
  created() {
    this.simple.id = this.input.id;
    this.simple.code = this.input.code;
    this.simple.overridable = this.input.overridable;
    this.simple.description = this.input.description;

    const min = get(this.input.validation, 'min') || null;
    this.simple.value = get(this.input.Measurement, 'value') || min;
    this.update(this.simple.value);
  },
};
</script>



// WEBPACK FOOTER //
// src/components/pages/professional/persons/participants/participant-evolution/measurement/tracked-measurements-form-input-groups/form-input-types/cmpt-form-input-simple-with-suggestions.vue